import { render, staticRenderFns } from "./teacher-info.vue?vue&type=template&id=641b256a&scoped=true"
import script from "./teacher-info.vue?vue&type=script&lang=js"
export * from "./teacher-info.vue?vue&type=script&lang=js"
import style0 from "./teacher-info.vue?vue&type=style&index=0&id=641b256a&prod&lang=stylus&scoped=true"
import style1 from "./teacher-info.vue?vue&type=style&index=1&id=641b256a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641b256a",
  null
  
)

export default component.exports